import { useState, useEffect } from "react";

const DESKTOP_BREAKPOINT = 1024;

interface ResponsiveState {
  isDesktop: boolean;
  isMobile: boolean;
  windowWidth: number;
}

export const useResponsive = (): ResponsiveState => {
  const [state, setState] = useState<ResponsiveState>(() => ({
    isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
    isMobile: window.innerWidth < DESKTOP_BREAKPOINT,
    windowWidth: window.innerWidth,
  }));

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${DESKTOP_BREAKPOINT}px)`,
    );

    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setState({
        isDesktop: e.matches,
        isMobile: !e.matches,
        windowWidth: window.innerWidth,
      });
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return state;
};
